module.exports = __webpack_public_path__ + "static/dash-2-87c2854fc07f64ecdad929bb78987fd6.png";